import { render, staticRenderFns } from "./FluxCube.vue?vue&type=template&id=24c25ac4&"
import script from "./FluxCube.vue?vue&type=script&lang=js&"
export * from "./FluxCube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports